<template>
<v-card flat>
  <!-- <v-card-title class='subtitle-1 overline' >
    Share link
  </v-card-title> -->
  <!-- <v-img height='180px' src='https://images.unsplash.com/photo-1523821741446-edb2b68bb7a0?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=300&q=80' > -->
  <v-img
    :src="bgImage"
    aspect-ratio="2.75" height='170' >
    <center>
    <v-img v-if='qr'
      style='border:solid 2px black;'
      width='150px' height='150px' class='elevation-20 mt-2'
      :src='qr' >
    </v-img>
    </center>
  </v-img>
  <slot name="card-title" >
    <v-card-title class="subheading">
      Share: {{link.title}}
      <v-spacer/>
      <v-btn icon :href="link.url" :title="link.title" target="_blank" >
        <v-icon>open_in_new</v-icon>
      </v-btn>
    </v-card-title>
  </slot>
  <v-divider></v-divider>
  <v-alert outline :value=true type='info' class='pa-2 mx-3' >
    <!-- R: {{relationship}} -->
    Point your phone's camera at this code to open the link
  </v-alert >
  <v-card-text >
    <copy-text-field :text-to-copy="link.url" label='Copy link to clipboard' >
    </copy-text-field>
    <v-list dense three-line v-if='email || phone || firstName' class='mt-0 pa-0' >
      <v-subheader class='mt-0 py-0 overline' >Contact information</v-subheader>
      <v-list-tile >
        <v-list-tile-content>
          <v-list-tile-title >
            {{firstName}} {{lastName}}
          </v-list-tile-title>
          <v-list-tile-sub-title v-text='phone' ></v-list-tile-sub-title>
          <v-list-tile-sub-title v-text='email' ></v-list-tile-sub-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-list>

  </v-card-text>
  <v-divider></v-divider>
  <v-card-actions >
    <v-btn color="success"
      :href="whatsappIt(phone, link.url)" target="_blank" block >Whatsapp
      <v-spacer></v-spacer>
      <v-icon small>open_in_new</v-icon>
    </v-btn>
    <v-btn color="primary"
      :href="mailIt(email, link)" target="_blank" block >Open in mail
      <v-spacer></v-spacer>
      <v-icon small>open_in_new</v-icon>
    </v-btn>
    <v-btn v-if='canShare' @click='share' icon ><v-icon>more_vert</v-icon></v-btn>
  </v-card-actions>
</v-card>
</template>
<script>
import CopyTextField from '@/components/ui/CopyTextField'
export default {
  name: 'ShareCard',
  components: {CopyTextField},
  props: {
    links: { type: Array, default: () => { return [] } },
    relationshipId: { required: false },
    bgImage: {
      type: String,
      default: 'https://cdn.vuetifyjs.com/images/cards/desert.jpg'
    }
  },
  computed: {
    link () {
      if (this.links && this.links.length > 0) {
        return this.links[0]
      }
    },
    qr () {
      if (this.link) {
        let base = 'https://api.qrserver.com/v1/create-qr-code/?size=200x200&data='
        return base + this.link.url
      }
    },
    relationship () {
      if (this.relationshipId) {
        let rel = this.$store.getters.getClientByRelationshipId(this.relationshipId)
        if (rel) { return rel }
      }
      return {}
    },
    firstName () {
      return this.getObjectPath(this.relationship, 'client.first_name', null)
    },
    lastName () {
      return this.getObjectPath(this.relationship, 'client.last_name', null)
    },
    email () {
      let email = this.getObjectPath(this.relationship, 'client.email', null)
      if (this.isRealEmail(email)) { return email }
      return null
    },
    phone () {
      return this.getObjectPath(this.relationship, 'client.phone_number', null)
    },
    canShare () {
      if (navigator.share) { return true }
      return false
    }
  },
  methods: {
    async share () {
      if (navigator.share) {
        try {
          await navigator.share(this.link)
        } catch (e) {
          console.error(e)
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// ShareCard.vue?781cf57c